import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST:
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
